export default __webpack_public_path__ + "static/media/tire.ed9c37ee.png";